import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const redirect = sessionStorage.redirect;
delete sessionStorage.redirect;

if (redirect) {
  window.history.replaceState(null, null, redirect);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();